module.exports = "abc"


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/raw-loader!./loaders/_resources/abc.txt
 ** module id = 1
 ** module chunks = 0
 **/